import { RewardDistributionType } from 'routes/singleEvent/types/reward-distribution.types';

export const AUTO_DISTRIBUTION_TYPES: RewardDistributionType[] = [
  'Instantly',
  'Instantly (Claim Required)',
  'Periodically (Auto)',
];

export const COLUMNS = [
  { key: 'name', header: 'Task Name' },
  { key: 'completedOn', header: 'Completed On' },
  { key: 'reward', header: 'Reward' },
  { key: 'distributionStatus', header: 'Distribution Status' },
];
